import { render, staticRenderFns } from "./GFOverview.vue?vue&type=template&id=025957d2"
import script from "./GFOverview.vue?vue&type=script&lang=js"
export * from "./GFOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports